export default {
	title: "Attendance Cards",
	cards: "Attendance Cards",
	newCard: "New Card",
	editCard: "Edit Card",
	deleteCard: "Delete Card",
	noCards: "No cards configured",
	noCardsDescription: "Add attendance cards to configure the service types for this ritual",
	form: {
		hasQueueLabel: "Has Queue",
		attendanceTypeLabel: "Attendance Type",
		attendanceTypeHint: "Select the attendance type to link to this ritual",
		maxTicketsOverrideLabel: "Ticket Limit (override)",
		maxTicketsOverrideHint: "Leave empty to use the attendance type default",
		defaultMaxTickets: "Default",
		typeInfo: "Type configuration",
	},
	numberingModes: {
		INCREMENTAL: "On demand",
		PRE_DEFINED: "Fixed",
		incrementalDescription: "Tickets added one by one, on demand",
		preDefinedDescription: "Shows all tickets from 1 to N at once",
	},
	messages: {
		created: "Attendance card created successfully",
		updated: "Attendance card updated successfully",
		deleted: "Attendance card deleted successfully",
		deleteError: "Error deleting attendance card",
		loadError: "Error loading attendance cards",
		copied: "Attendance cards imported successfully",
		copyError: "Error importing attendance cards",
	},
	deleteConfirmation: "Are you sure you want to delete the card {label}?",
	deleteWarning: "This action cannot be undone.",
	copyFrom: "Import Cards",
	copyFromTitle: "Import Card Structure from Another Ritual",
	copyFromHint: "Select a ritual type to copy its attendance links",
	copyFromPlaceholder: "Select the source ritual type",
	overridden: "Overridden",
	validation: {
		maxTicketsMin: "Minimum quantity is 1",
		attendanceTypeRequired: "Attendance type is required",
	},
};
